import TiredPenguinSvg from "./tired.svg";

export function TiredPenguin() {
  return <TiredPenguinSvg />;
}
